// import components
import { StyledBoxFlexColumn } from 'components/shared/Box/Box.styles';
import { StyledHeaderTypography } from '../AIMatch.styles';
import { AIMatchSettings } from './AIMatchSettings';

// import hooks
import { useTranslation } from 'react-i18next';

// import types
import { AIMatchSettingsType } from 'components/types';
import { AIMatchNotificationsProps } from './AIMatchNotifications.types';

const AIMatchNotifications = ({ isLoading }: AIMatchNotificationsProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'aiMatchSettings' });

  return (
    <StyledBoxFlexColumn>
      <StyledHeaderTypography variant="h6">
        {t('notifications')}
      </StyledHeaderTypography>
      <AIMatchSettings type={AIMatchSettingsType.TIMES} isLoading={isLoading} />
      <AIMatchSettings
        type={AIMatchSettingsType.BEFORE_START_LIMIT}
        isLoading={isLoading}
      />
      <AIMatchSettings
        type={AIMatchSettingsType.ROUND_MINUTES_BEFORE_START_LIMIT}
        isLoading={isLoading}
      />
    </StyledBoxFlexColumn>
  );
};

export default AIMatchNotifications;
